import React from 'react';
import { withTranslation } from 'react-i18next';
import ImgLazyLoad from 'src/screens/WhiteLabels/Templates/shared/components/ImgLazyLoad';
// material ui
import { LinkOutlined, RoomOutlined, CallOutlined, EmailOutlined } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
// images
import SnapIcon from '../../../assets/images/socialIcon/snapchat.png';
import FbIcon from '../../../assets/images/socialIcon/facebook.svg';
import TwitterIcon from '../../../assets/images/socialIcon/twitter.svg';
import InstaIcon from '../../../assets/images/socialIcon/instagram.svg';

const useStyles = makeStyles({
    mainDiv:{
        width:'calc(100% - 20px)',
        display:'flex',
        flexDirection:'column',
        borderRadius:'5px',
        backgroundColor:'#fff',
        padding:'0px 10px 25px 10px',
        marginBottom:'30px',
        boxShadow:'0px 1px 2px #00000038'
    },

    marRight:{
        marginRight:'10px',
    },
    marLeft:{
        marginLeft:'10px',
    },

    rowDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        marginTop:'10px'
    },

    webLink:props => ({
        color: props.fontDarkColor ? props.fontDarkColor : '#000',
        maxWidth: '70%',
        fontSize:'14px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textDecoration:'none',
        cursor:'pointer'
    }),

    mapDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'flex-start',
        justifyContent: 'space-between',
        maxWidth: '80%',
        width:'100%',
    },

    seeMap:{
        color:'#0AB8E5',
        borderBottom:'1px solid #0AB8E5',
        cursor:'pointer',
        fontSize:'10px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },

    socialIcon:{
        width:'50px',
        height:'50px',
        cursor:'pointer'
    },

    header:{
        fontSize:'20px',
        marginTop:'20px',
        color:'#000',
        fontWeight:'bold',
        textTransform:'capitalize',
        textAlign:'center',
        maxWidth: '90%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }
});

function SocialSection(props) {    
    const { t, i18n,webPage, email, phoneNumber, snapChat, facebookPage, twitterPage, instagramPage, lat, long, address, fontDarkColor,phoneVisible, mapVisible, socialVisible } = props;

    const openLink = link => { // open web link on new tab
        window.open(link,'_blank')
    }
    const redirectMap = () => { // open location on google map with lat and long
        window.open(`https://maps.google.com/?q=${lat},${long}`,'_blank','noopener,resizable,scrollbars');
    }

    const classes = useStyles({fontDarkColor});
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <div className={classes.mainDiv}>
            <span className={classes.header} style={{fontFamily,textAlign:isRTL === 'ar' ? 'right' : 'left'}}>{t('companyPage.contactus')}</span>
            {email ?
                <div className={classes.rowDiv}>
                    <EmailOutlined style={{color:'#4AAEE2'}}/>
                    <a className={`${classes.webLink} ${isRTL === 'ar' ? classes.marRight : classes.marLeft}`} style={{fontFamily}} href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">{email}</a>
                </div>
            :
            undefined
            }

            {webPage ?
                <div className={classes.rowDiv}>
                    <LinkOutlined style={{color:'#4AAEE2'}}/>
                    <a className={`${classes.webLink} ${isRTL === 'ar' ? classes.marRight : classes.marLeft}`} style={{fontFamily}} href={webPage} target="_blank" rel="noopener noreferrer">{webPage}</a>
                </div>
            :
            undefined
            }

            {mapVisible ?
                <div className={classes.rowDiv} style={{alignItems:'flex-start'}}>
                    <RoomOutlined style={{color:'#0F467A'}}/>
                    <div className={`${classes.mapDiv} ${isRTL === 'ar' ? classes.marRight : classes.marLeft}`}>
                        <span className={classes.webLink} style={{fontFamily,whiteSpace:'break-spaces'}}>{address}</span>
                        {lat && long ? <span className={classes.seeMap} style={{fontFamily}} onClick={redirectMap}>{t('companyPage.seemap')}</span> : undefined}
                    </div>
                </div>
            :
                null
            }

            {phoneVisible && phoneNumber ?
            <div className={classes.rowDiv}>
                <CallOutlined style={{color:'#4AAEE2'}}/>
                <a className={`${classes.webLink} ${isRTL === 'ar' ? classes.marRight : classes.marLeft}`} style={{fontFamily}} href={"tel:"+phoneNumber} target="_blank" rel="noopener noreferrer">{phoneNumber}</a>
            </div>
            :
            undefined
            }
            {/* social buttons */}
            {socialVisible ?
                <div className={classes.rowDiv} style={{justifyContent:'space-around'}}>
                    {snapChat ? <ImgLazyLoad><img src={SnapIcon} alt='socialIcon' onClick={()=> openLink(snapChat)} className={classes.socialIcon}/></ImgLazyLoad> : undefined}
                    {facebookPage ? <ImgLazyLoad><img src={FbIcon} alt='socialIcon' onClick={()=> openLink(`https://facebook.com/${facebookPage}`)} className={classes.socialIcon}/></ImgLazyLoad> : undefined}
                    {twitterPage ? <ImgLazyLoad><img src={TwitterIcon} alt='socialIcon' onClick={()=> openLink(`https://twitter.com/${twitterPage}`)} className={classes.socialIcon}/></ImgLazyLoad> : undefined}
                    {instagramPage ? <ImgLazyLoad><img src={InstaIcon} alt='socialIcon' onClick={()=> openLink(`https://instagram.com/${instagramPage}`)} className={classes.socialIcon}/></ImgLazyLoad> : undefined}
                </div>
            :
                null    
            }
        </div>
    )
}

export default withTranslation('common')(SocialSection);